import { ReactElement, useEffect, useState, ChangeEvent } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, Tab, Tabs
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import TabPanel from "../../../../components/tabPanel";
import { useSelector } from "react-redux";
import { IState } from "../../../../types";
import FamilyConfig from "./familyConfig";
import { cloneObject } from "../../../../system/utils";
import { IFamilyBase, IProductBase } from "../../types";
import FamilyProductPanel from "./familyProductPanel";
import { useFetch } from "../../../../system/useFetch";

interface IProps {
  family: IFamilyBase;
  onAccept: (family: IFamilyBase) => void;
  onCancel: () => void;
}

const a11yProps = (index: number): any => {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
};

const FamilyDialog = ({ onAccept, onCancel, family }: IProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const selectedNode = useSelector((state: IState) => state.selectedNode);
  const [tabSelected, setTabSelected] = useState(0);
  const [cloned, setCloned] = useState<IFamilyBase>(cloneObject(family));
  const [right, setRight] = useState<IProductBase[]>([]);
  const { data } = useFetch<IProductBase[]>(
    {
      module: "production",
      query: "getProducts",
      payload: {
        nodeID: selectedNode.nodeID,
        nodeType: selectedNode.type
      }
    });

  useEffect(() => {
    if (data) {
      setRight(data.filter(x => (cloned.products ?? []).find(y => y.productID === x.productID) !== undefined));
    }
  }, [data]);


  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setTabSelected(newValue);
  };

  const onInternalAccept = () => {
    for (let i = cloned.products.length - 1; i >= 0; i--) {
      if (!right.find(x => x.productID === cloned.products[i].productID)) {
        // cloned.products.splice(i, 1);
        cloned.products[i].status = -1;
      }
    }

    for (const item of right) {
      if (!cloned.products.find(x => x.productID === item.productID)) {
        cloned.products.push({
          familyGroupID: 0,
          productName: item.reference,
          productID: item.productID,
          nodeID: item.nodeID,
          nodeType: item.nodeType,
          status: 1
        });
      }
    }

    onAccept(cloned);
  };

  return (
    <Dialog onClose={onCancel} aria-labelledby="customized-dialog-title" open={true} maxWidth="md" keepMounted={true}>
      <DialogTitle id="customized-dialog-title">
        Specification
      </DialogTitle>
      <DialogContent dividers={true} style={{ width: 570 }} >
        <Tabs
          value={tabSelected}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered={true}
          style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
          <Tab label="Info" {...a11yProps(0)} />
          <Tab label="Products" {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={tabSelected} index={0} >
          <FamilyConfig family={cloned} setFamily={setCloned} />
        </TabPanel>
        <TabPanel value={tabSelected} index={1} >
          <FamilyProductPanel right={right} setRight={setRight} products={data}/>
        </TabPanel>
      </DialogContent>
      <DialogActions>
        <Button onClick={onInternalAccept} variant="contained" color="primary" startIcon={<CheckIcon />}>
          Accept
        </Button>
        <Button onClick={onCancel} variant="contained" color="secondary" startIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FamilyDialog;
